import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import CardList from './components/CardList';
import Filters from './components/Filters';
import CardModal from './components/CardModal';
import Pagination from './components/Pagination';
import Categories from './components/Categories';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ActiveFilters from './components/ActiveFilters';
import axios from 'axios';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import SettingsModal from './components/SettingsModal';
import SupportWebsiteModal from './components/SupportWebsiteModal';
import UserProfile from './components/UserProfile';
import { useUser } from './UserContext'; // Import the useUser hook
import './main.css';
import { Navbar, Nav, Form, FormControl, Button, NavDropdown, Container, Offcanvas, Spinner } from 'react-bootstrap'; // Import Bootstrap components
import { FaBars, FaBell } from 'react-icons/fa';
import { useSwipeable } from 'react-swipeable';
import NotificationsPage from './components/NotificationsPage'; // Import the NotificationsPage component
import { Outlet, Link } from "react-router-dom";
import { buildUrlWithParams } from './components/utils.js'
import CustomScrollRestoration from './components/CustomScrollRestoration';

import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
//import './mobile.css';
import { FaDiaspora, FaBug, FaShieldAlt, FaSearch } from "react-icons/fa";
import { IoMdChatboxes, IoIosRibbon } from "react-icons/io";
import { FaNewspaper, FaLightbulb } from "react-icons/fa6";
import { ModeratorActionProvider } from './ModeratorActionContext';
import ContestButton from './components/ContestButton';

function getCookie(cookieName) {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return null;
}


function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [searchParams, setSearchParams] = useSearchParams();

    // NEW Search State
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState({ cards: [], users: [], contests: [] });
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [loadingSuggestions, setLoadingSuggestions] = useState(false);
    const searchFormRef = React.useRef(null); // For click-outside-to-close

      // State for card image preview in suggestions
  const [hoveredCardPreview, setHoveredCardPreview] = useState({
    id: null,
    cardid: null,
    cardName: '', // For alt text
    top: 0,
    left: 0,
    visible: false,
    loadingImage: false,
  });

    // Event handler for mouse entering a card suggestion
    const handleCardSuggestionMouseEnter = (card, event) => {
      const rect = event.currentTarget.getBoundingClientRect();
      const previewWidth = 200 + 10; // Approximate width of preview (200px + padding/border)
      const previewHeight = 280 + 10; // Approximate height (280px + padding/border)
      const gap = 15; // Gap between suggestion item and preview
  
      let left = rect.right + gap;
      let top = rect.top;
  
      // Adjust if preview goes off-screen to the right
      if (left + previewWidth > window.innerWidth) {
        left = rect.left - previewWidth - gap;
      }
      // Adjust if preview goes off-screen to the left (e.g., if initial position was left and then adjusted right)
      if (left < 0) {
        left = gap; // Fallback to a small gap from the left edge
      }
  
      // Adjust if preview goes off-screen to the bottom
      if (top + previewHeight > window.innerHeight) {
        top = Math.max(window.innerHeight - previewHeight - gap, gap); // Ensure it doesn't go above screen top
      }
      // Adjust if preview goes off-screen to the top
      if (top < 0) {
        top = gap;
      }
  
      setHoveredCardPreview({
        id: card.id,
        cardid: card.cardid,
        cardName: card.cardname,
        top: top,
        left: left,
        visible: true,
        loadingImage: true,
      });
    };
  
    // Event handler for mouse leaving a card suggestion
    const handleCardSuggestionMouseLeave = useCallback(() => {
      setHoveredCardPreview(prev => ({
        ...prev, // Keep position to avoid flicker if re-hovering same area
        id: null,
        cardid: null,
        cardName: '',
        visible: false,
        loadingImage: false,
      }));
    }, [setHoveredCardPreview]);

  // Effect to hide preview when suggestions box is hidden for any reason
  useEffect(() => {
    if (!showSuggestions) {
      handleCardSuggestionMouseLeave();
    }
  }, [showSuggestions, handleCardSuggestionMouseLeave]);

  const [selectedCard, setSelectedCard] = useState(params.get('selectedCard') || null);
  const [currentPage, setCurrentPage] = useState(parseInt(params.get('page'), 10) || 1);
  const [totalPages, setTotalPages] = useState(1);

  const [unreadNotifications, setUnreadNotifications] = useState(0);

  const { user, setUser, filters, setFilters, cards, setCards } = useUser();


  useEffect(() => {
    const fetchNotifications = async () => {
      if (user) {
        try {
          const response = await axios.get('/api/users/notifications_time.php');
          const unreadCount = response.data.notifications.filter(n => !n.is_read).length;
          setUnreadNotifications(unreadCount);
        } catch (error) {
          console.error('Error fetching notifications:', error);
        }
      }
    };

    fetchNotifications();
    // Set up an interval to check for new notifications every 20 seconds
    const intervalId = setInterval(fetchNotifications, 20 * 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [user]);


  useEffect(() => {
    //console.log(params.get('selectedCard'));
    setSelectedCard(params.get('selectedCard') || null);
  }, [params.get('selectedCard')]);

  const [settings, setSettings] = useState({
    cardsPerRow: localStorage.getItem('cardsPerRow') || 2,
    language: getCookie('language_creator') || 'en',
  });


  // Contest Data for ContestButton
  const [contests, setContests] = useState([]);
  useEffect(() => {
    const fetchContests = async () => {
      try {
        const response = await fetch('/api/contest/initial_contests.php');
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        if (!Array.isArray(data)) {
            console.error("API did not return an array:", data);
            throw new Error("Invalid data format received from server.");
        }
        setContests(data);
      } catch (err) {
        console.error("Failed to fetch contests:", err);
      } finally {
      }
    };
    fetchContests();
  }, []);




  const [showSettings, setShowSettings] = useState(false);
  const [showSupportWebsite, setShowSupportWebsite] = useState(false);
  const [isLoading, setIsLoading] = useState(0);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const handleNotificationsClick = () => {
    setShowNotifications(true);
  };

  const handleCloseNotifications = () => {
    setShowNotifications(false);
  };

  const handleToggleSidebar = () => setShowSidebar(!showSidebar);

  const swipeHandlers = useSwipeable({
    onSwiped: (eventData) => {
      if (window.getSelection && window.getSelection().toString().length > 0) {
        return;
      }

      const screenWidth = window.innerWidth;
      const swipeDistance = Math.abs(eventData.deltaX);
      const swipeThreshold = screenWidth * 0.3;

      if (selectedCard) {
        const currentCardIndex = cards.findIndex(card => card.id === selectedCard);
        const cardModal = document.querySelector('.card-modal');
        if (swipeDistance >= swipeThreshold) {
          if (eventData.dir === 'Right') {
            if (currentCardIndex > 0) {
              // Previous card
              const newSelectedCard = cards[currentCardIndex - 1].id;
              setSelectedCard(newSelectedCard);
              params.set('selectedCard', newSelectedCard);
              if (cardModal) {
                cardModal.scrollTo({ top: 0, behavior: 'smooth' });
              }
            } else if (currentPage > 1) {
              params.set('page', currentPage - 1);
            }
          } else if (eventData.dir === 'Left') {
            if (currentCardIndex < cards.length - 1) {
              // Next card
              const newSelectedCard = cards[currentCardIndex + 1].id;
              setSelectedCard(newSelectedCard);
              params.set('selectedCard', newSelectedCard);
              if (cardModal) {
                cardModal.scrollTo({ top: 0, behavior: 'smooth' });
              }
            } else if (currentPage < totalPages) {
              params.set('page', currentPage + 1);
            }
          }

          navigate({ search: params.toString() }, { replace: true });
        }
      } else {
        if (swipeDistance >= swipeThreshold) {
          if (eventData.dir === 'Right') {
            setShowSidebar(true);
          } else if (eventData.dir === 'Left') {
            setShowSidebar(false);
          }
        }
      }
    },
    trackMouse: false,
    preventDefaultTouchmoveEvent: true,
  });

  useEffect(() => {
    // const token = localStorage.getItem('token');

    // Attempt to retrieve the token from localStorage
    let token = null;

    // If the token does not exist, check for 'hcardss' in cookies
    if (!token) {
      const cookies = document.cookie.split('; ');
      const hcardssCookie = cookies.find(cookie => cookie.startsWith('hcardss='));
      //console.log(cookies);
      if (hcardssCookie) {
        token = hcardssCookie.split('=')[1]; // Extract the token value from 'hcardss' cookie
      }
    }

    // Function to delete the 'hcardss' cookie
    const deleteCookie = (name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    };

    if (token) {
      axios.post('/api/auth/auth.php', { action: 'check', token: token })
        .then(response => {
          const hc = response.data.hc;
          //console.log(hc);
          if (hc.loggedin) {
            setUser({
              userid: hc.userid,
              username: hc.username,
              rank: hc.rank,
              mod: hc.mod,
              profile_picture: hc.picture,
              supIcon: hc.supIcon,
              supColor: hc.supColor

            });
          } else {
            localStorage.removeItem('token');
            deleteCookie('hcardss');
          }
        })
        .catch(() => {
          localStorage.removeItem('token');
          deleteCookie('hcardss');
        });
    }
  }, []);

  const handleLogin = (user) => {
    setUser(user);
  };

  const handleLogout = async () => {
    // Function to delete the 'hcardss' cookie
    const deleteCookie = (name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    };

    try {
      await axios.post('/api/auth/auth.php', {
        action: 'logout',
      });

      localStorage.removeItem('token');
      deleteCookie('hcardss');
      setUser(null);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  

  const handleCardClick = (card) => {
    setSelectedCard(card.id);
  };

  const handleCloseModal = () => {
    setSelectedCard(null);

    params.delete('selectedCard');
    //console.log(params);
    navigate({ search: params.toString() }, { replace: true });
    document.body.classList.remove('no-scroll');
  };

  useEffect(() => {
    if (params.get('selectedCard')) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [params.get('selectedCard')]);

  const handleSettingsOpen = () => {
    setShowSettings(true);
  };

  const handleSettingsClose = () => {
    setShowSettings(false);
  };

  const handleSettingsSave = (newSettings) => {
    //console.log(newSettings);
    setSettings(newSettings);
    setShowSettings(false);
  };

  //   const handleBackFromUserProfile = () => {
  //   setSelectedUser(null);
  // };


  // useEffect for fetching search suggestions (debounced)
  useEffect(() => {
    if (searchTerm.trim().length < 1) { // Min 1 char
      setSuggestions({ cards: [], users: [], contests: [] });
      setShowSuggestions(false);
      return;
    }

    const debounceTimeout = setTimeout(async () => {
      setLoadingSuggestions(true);
      try {
        const response = await axios.get(`/api/search_suggestions.php?q=${encodeURIComponent(searchTerm)}`);
        setSuggestions(response.data);
        // Show suggestions only if there are any results
        const hasResults = response.data.cards?.length > 0 || response.data.users?.length > 0 || response.data.contests?.length > 0;
        setShowSuggestions(hasResults);
      } catch (error) {
        console.error('Error fetching search suggestions:', error);
        setSuggestions({ cards: [], users: [], contests: [] });
        setShowSuggestions(false);
      } finally {
        setLoadingSuggestions(false);
      }
    }, 300); // 300ms debounce

    return () => clearTimeout(debounceTimeout);
  }, [searchTerm]);

  // useEffect for handling clicks outside the search suggestion dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchFormRef.current && !searchFormRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [searchFormRef, handleCardSuggestionMouseLeave]);


  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value === '') {
      setShowSuggestions(false);
      // Original logic for clearing other search-related URL params if search input is emptied
      setSearchParams(prevParams => {
        prevParams.delete('category');
        prevParams.delete('page');
        prevParams.delete('search'); // This 'search' param might be for main CardList filtering
        return prevParams;
      });
    } else if (value.trim().length >= 1) {
        // setShowSuggestions(true); // Let useEffect handle showing based on results
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const trimmedSearchTerm = searchTerm.trim();
    if (trimmedSearchTerm) {
      navigate(`/search-results?q=${encodeURIComponent(trimmedSearchTerm)}`);
      setShowSuggestions(false);
      // Do not clear searchTerm here, so user sees what they searched for on the new page (if they navigate back)
      // Or clear it if preferred: setSearchTerm('');
    }
  };

  const handleSuggestionClick = (item, type) => {
    setShowSuggestions(false);
    handleCardSuggestionMouseLeave();
    setSearchTerm(''); // Clear search input after selection
    
    if (type === 'card') {
      const cardId = item.id;
      // Navigate to home page (or gallery page) with selectedCard
      // This ensures the card modal appears on a consistent base page.
      const newSearchParams = new URLSearchParams();
      newSearchParams.set('selectedCard', cardId);
      navigate(buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: cardId }));
    } else if (type === 'user') {
      navigate(`/user/${item.id}`);
    } else if (type === 'contest') {
      navigate(`/contests/${item.id}`); // Make sure this route is defined
    }
    setSearchTerm(''); // Clear search term after action
  };

  // Destructure for use in JSX to ensure values are from the same state snapshot in callbacks
  const {
    id: currentPreviewId,
    cardid: currentPreviewCardId,
    cardName: currentPreviewCardName,
    top: currentPreviewTop,
    left: currentPreviewLeft,
    visible: isPreviewVisible,
    loadingImage: isPreviewImageLoading
  } = hoveredCardPreview;



  if (showLoginForm) {
    return (<LoginForm onClose={() => setShowLoginForm(false)} />)
  }
  //{!user && <Login setUser={handleLogin} />}
  return (
    <>
      <ModeratorActionProvider>
        <div {...swipeHandlers}>
          <Navbar bg="light" className="sticky-top">
            <Container fluid>
              <Button variant="link" className="me-2 d-sm-none" onClick={handleToggleSidebar} style={{ paddingLeft: '0.3rem', paddingRight: '0.3rem' }}>
                <FaBars style={{ color: 'rgb(222, 167, 0)', fontSize: '1.5rem', verticalAlign: '-.4rem' }} />
              </Button>
              <Navbar.Brand href="/">
                <img
                  src="/gallery/images/hearthcards-logo.webp"
                  width="30"
                  height="30"
                  className="d-inline-block align-top"
                  alt="HearthCards Logo"
                />

              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                {/* UPDATED SEARCH FORM */}
                <Form className="mx-auto d-flex position-relative search-form-wrapper" onSubmit={handleSearchSubmit} ref={searchFormRef}>
                  <FormControl
                    type="search"
                    placeholder="Search Cards, Users, Contests..."
                    className="navbar-search-input me-2"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={handleSearchInputChange}
                    onFocus={() => { // Show suggestions on focus if term exists and has results
                        if (searchTerm.trim().length >= 1 && (suggestions.cards?.length || suggestions.users?.length || suggestions.contests?.length)) {
                           setShowSuggestions(true);
                        }
                    }}
                    // onKeyDown removed - using Form onSubmit
                  />
                  {/* Optional: A search button if you want one, but Enter key works */}
                  {/* <Button type="submit" variant="outline-secondary" size="sm"><FaSearch /></Button> */}

                  {showSuggestions && searchTerm.trim().length >= 1 && (
                    <div className="search-suggestions-dropdown shadow-sm">
                      {loadingSuggestions && <div className="suggestion-item p-2 text-muted"><i>Loading...</i></div>}
                      {!loadingSuggestions && (
                        <>
                          {suggestions.cards && suggestions.cards.length > 0 && (
                            <>
                              <div className="suggestion-category">Cards</div>
                              {suggestions.cards.map(card => (
                                <div
                                  key={`card-${card.id}`}
                                  className="suggestion-item"
                                  onMouseDown={() => handleSuggestionClick(card, 'card')}
                                  onMouseEnter={(e) => handleCardSuggestionMouseEnter(card, e)} // ADDED
                                  onMouseLeave={handleCardSuggestionMouseLeave} // ADDED
                                >
                                  {card.cardname}
                                </div>
                              ))}
                            </>
                          )}
                          {suggestions.users && suggestions.users.length > 0 && (
                            <>
                              <div className="suggestion-category">Users</div>
                              {suggestions.users.map(user => (
                                <div key={`user-${user.id}`} className="suggestion-item"
                                     onMouseDown={() => handleSuggestionClick(user, 'user')}>
                                  {user.username}
                                </div>
                              ))}
                            </>
                          )}
                          {suggestions.contests && suggestions.contests.length > 0 && (
                            <>
                              <div className="suggestion-category">Contests</div>
                              {suggestions.contests.map(contest => (
                                <div key={`contest-${contest.id}`} className="suggestion-item"
                                     onMouseDown={() => handleSuggestionClick(contest, 'contest')}>
                                  {contest.title}
                                </div>
                              ))}
                            </>
                          )}
                          {/* Link to full search results page, shown if there are suggestions or if no suggestions but user typed something */}
                          <div
                            className="suggestion-item suggestion-item-full-search"
                            onMouseDown={(e) => { // Use onMouseDown
                                e.preventDefault(); // Prevent input from losing focus before navigation
                                // Manually trigger form submission logic
                                const mockEvent = { preventDefault: () => {} }; // Create a mock event
                                handleSearchSubmit(mockEvent);
                            }}
                          >
                            <FaSearch className="me-2" /> Search all results for "{searchTerm}"
                          </div>
                        </>
                      )}
                       {!loadingSuggestions &&
                            searchTerm.trim().length >= 1 &&
                            !suggestions.cards?.length &&
                            !suggestions.users?.length &&
                            !suggestions.contests?.length && (
                                <div className="suggestion-item p-2 text-muted"><i>No direct suggestions found.</i></div>
                            )
                        }
                    </div>
                  )}
                </Form>


                <Nav>

                  {user ? (
                    <>
                      <NavDropdown align="end"
                        title={
                          <div className="pull-left">
                            <span className="d-none d-sm-inline">{user.username}</span>
                            <div className="position-relative d-inline-block">
                              <img
                                className="navbar-userpic rounded-circle ms-2"
                                // src={user?.profile_picture ? `/images/users/pictures/${user.profile_picture}` : "/gallery/images/profile-image.jpg"}
                                src={
                                  user?.profile_picture
                                    ? (user.profile_picture.includes('http')
                                      ? user.profile_picture
                                      : `/images/users/pictures/${user.profile_picture}`)
                                    : "/gallery/images/profile-image.jpg"
                                }
                                alt="user pic"
                                style={{ width: "30px", height: "30px", objectFit: "cover" }}
                              />
                              {unreadNotifications > 0 && (
                                <span className="position-absolute top-0 end-0 translate-end p-1 bg-danger border border-light rounded-circle">
                                  <span className="visually-hidden">New notifications</span>
                                </span>
                              )}
                            </div>
                          </div>
                        } id="basic-nav-dropdown">
                        <NavDropdown.Item as={Link} to={`/user/${user.userid}`}>Profile</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/notifications"> {unreadNotifications > 0 && (<FaBell />)} Notifications </NavDropdown.Item>
                        <NavDropdown.Item onClick={handleSettingsOpen}>Settings</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setShowSupportWebsite(true)}>Donate</NavDropdown.Item>

                        {user?.mod && (
                          <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/reports">
                              <FaShieldAlt /> Reports
                            </NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/moderation">
                              <FaShieldAlt /> Mod Log
                            </NavDropdown.Item>
                            <NavDropdown.Divider />
                          </>
                        )}


                        <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
                      </NavDropdown>
                    </>
                  ) : (
                    <NavDropdown align="end"
                      title={
                        <div className="pull-left">
                          Sign In
                          <img className="navbar-userpic rounded-circle ms-2"
                            src="/gallery/images/profile-image.jpg"
                            alt="user pic"
                            style={{ width: "30px", height: "30px", objectFit: "cover" }}
                          />
                        </div>
                      } id="basic-nav-dropdown">
                      <NavDropdown.Item onClick={handleSettingsOpen}>Settings</NavDropdown.Item>
                      <NavDropdown.Item onClick={() => setShowSupportWebsite(true)}>Donate</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item onClick={() => setShowLoginForm(true)}>Login</NavDropdown.Item>
                    </NavDropdown>

                  )}
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>


          {/* Mobile Sidebar */}
          <Offcanvas show={showSidebar} onHide={handleToggleSidebar} placement="start" responsive="lg" className="d-lg-none offcanvas-filters" style={{ maxWidth: '80%' }}>
            <div className="hc-panel-right-bottom"></div>
            {/* <Offcanvas.Header closeButton>
              <Offcanvas.Title>Filters and Categories</Offcanvas.Title>
            </Offcanvas.Header> */}
            <Offcanvas.Body>
              <button type="button" className="btn-close position-absolute top-0 end-0 m-3" aria-label="Close" onClick={handleToggleSidebar}></button>
              <div className="hc-panel-right-content-mobile mb-5">
                <Categories filters={filters} setFilters={setFilters} setCurrentPage={setCurrentPage} onCategoryClick={() => { window.scrollTo(0, 0); setShowSidebar(false) }} />

                <div className="mt-2 mb-3">
                  {/* <button type="button" className="btn btn-outline-success w-100" onClick={() => { setShowSidebar(false); setSelectedCard(10451208); } }>Friendly Chat</button>
                  <button type="button" className="btn btn-outline-success w-100 mt-1" onClick={() => { setShowSidebar(false); setSelectedCard('0'); } }>Bugs & Suggestions</button>
                  <button type="button" className="btn btn-outline-success w-100 mt-1" onClick={() => { setShowSidebar(false); setSelectedCard('13312404'); } }>Gallery Rules</button> */}
                  <span className="pt-3" onClick={() => { setShowSidebar(false); }} >

                  {contests.map((contest) => (
        <ContestButton
          key={contest.contestId} // Essential for list rendering in React
          settings={settings} // Pass the settings prop down
          contestId={contest.contestId}
          contestName={contest.contestName}
          contestImage={contest.contestImage}
          backgroundImage={contest.backgroundImage}
          start_date={contest.start_date}
          submissions_end_date={contest.submissions_end_date}
          end_date={contest.end_date}
          dropShadow={contest.dropShadow}
        />
      ))}

                  {/* <ContestButton
                      settings={settings}
                      contestId="15"
                      contestName="Missing Pieces"
                      contestImage="https://www.hearthcards.net/images/contest/sketch/15.svg"
                      backgroundImage="https://www.hearthcards.net/art/CORE_MAW_023.jpg"
                      start_date = "1742788800"
                      submissions_end_date = "1743220800"
                      end_date = "1743393600"
                      dropShadow = "dark"
                    />

                  <ContestButton
                      settings={settings}
                      contestId="10"
                      contestName="That Worked?!"
                      contestImage="https://www.hearthcards.net/images/contest/sketch/10.svg"
                      backgroundImage="https://www.hearthcards.net/images/contest/background/10.webp"
                      start_date = "1742184000"
                      submissions_end_date = "1742616000"
                      end_date = "1742788800"
                      dropShadow = "dark"
                    /> */}

                  </span>
                  <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 13919738 })} className="btn btn-outline-success w-100 filter pinned-news"><FaNewspaper /> News</Link>
                  <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 13312404 })} className="btn btn-outline-success w-100 mt-1 filter pinned-rules"><FaDiaspora /> Gallery Rules</Link>
                  {settings && settings.language && settings.language == 'ru' ? (
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 11965320 })} className="btn btn-outline-success w-100 mt-1 filter pinned-chat"><IoMdChatboxes /> Дружеский Чат</Link>
                  ) : (
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 10451208 })} className="btn btn-outline-success w-100 mt-1 filter pinned-chat"><IoMdChatboxes /> Friendly Chat</Link>
                  )
                  }
                  <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 0 })} className="btn btn-outline-success w-100 mt-1 filter pinned-bugs"><FaBug /> Bugs & Suggestions</Link>
                  <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 14316205 })} className="btn btn-outline-success w-100 mt-1 filter pinned-contest-ideas"><FaLightbulb /> Contest Ideas</Link>



                </div>

                <Filters filters={filters} setFilters={setFilters} setCurrentPage={setCurrentPage} />
              </div>
            </Offcanvas.Body>
          </Offcanvas>


          <div className="App container mt-1">

            <div className="row">
              <div className="hc-panel-left col-md-9 order-md-1 order-2 position-relative">
                <div className="hc-panel-left-bottom"></div>
                <div className="hc-panel-left-content">
                  <Outlet context={[cards, setCards, currentPage, setCurrentPage, totalPages, setTotalPages]} />
                </div>
              </div>
              <div className="hc-panel-right col-md-3 order-md-2 order-1 d-none d-sm-block position-relative">
                <div className="hc-panel-right-bottom"></div>
                <div className="hc-panel-right-content form-group pt-3">
                  {/* <label>Category:</label> */}
                  <div className="mt-2"><Categories filters={filters} setFilters={setFilters} setCurrentPage={setCurrentPage} onCategoryClick={() => { }} /></div>
                  <label>Pinned:</label>
                  <div>


                  {contests.map((contest) => (
        <ContestButton
          key={contest.contestId} // Essential for list rendering in React
          settings={settings} // Pass the settings prop down
          contestId={contest.contestId}
          contestName={contest.contestName}
          contestImage={contest.contestImage}
          backgroundImage={contest.backgroundImage}
          start_date={contest.start_date}
          submissions_end_date={contest.submissions_end_date}
          end_date={contest.end_date}
          dropShadow={contest.dropShadow}
        />
      ))}

                  {/* <ContestButton
                      settings={settings}
                      contestId="15"
                      contestName="Missing Pieces"
                      contestImage="https://www.hearthcards.net/images/contest/sketch/15.svg"
                      backgroundImage="https://www.hearthcards.net/art/CORE_MAW_023.jpg"
                      start_date = "1742788800"
                      submissions_end_date = "1743220800"
                      end_date = "1743393600"
                      dropShadow = "dark"
                    />

                  <ContestButton
                      settings={settings}
                      contestId="10"
                      contestName="That Worked?!"
                      contestImage="https://www.hearthcards.net/images/contest/sketch/10.svg"
                      backgroundImage="https://www.hearthcards.net/images/contest/background/10.webp"
                      start_date = "1742184000"
                      submissions_end_date = "1742616000"
                      end_date = "1742788800"
                      dropShadow = "dark"
                    /> */}


                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 13919738 })} className="btn btn-outline-success w-100 filter pinned-news"><FaNewspaper /> News</Link>
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 13312404 })} className="btn btn-outline-success w-100 mt-1 filter pinned-rules"><FaDiaspora /> Gallery Rules</Link>
                    {settings && settings.language && settings.language == 'ru' ? (
                      <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 11965320 })} className="btn btn-outline-success w-100 mt-1 filter pinned-chat"><IoMdChatboxes /> Дружеский Чат</Link>
                    ) : (
                      <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 10451208 })} className="btn btn-outline-success w-100 mt-1 filter pinned-chat"><IoMdChatboxes /> Friendly Chat</Link>
                    )
                    }
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 0 })} className="btn btn-outline-success w-100 mt-1 filter pinned-bugs"><FaBug /> Bugs & Suggestions</Link>
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 14316205 })} className="btn btn-outline-success w-100 mt-1 filter pinned-contest-ideas"><FaLightbulb /> Contest Ideas</Link>

                  </div>

                  <Filters filters={filters} setFilters={setFilters} setCurrentPage={setCurrentPage} />
                </div>
              </div>
            </div>



            {selectedCard && <CardModal card={selectedCard} setCards={setCards} user={user} onClose={handleCloseModal} />}
            {showSettings && <SettingsModal onClose={handleSettingsClose} onSave={handleSettingsSave} show={showSettings} />}
            {showSupportWebsite && <SupportWebsiteModal onClose={() => setShowSupportWebsite(false)} onSave={handleSettingsSave} show={showSupportWebsite} />}
          </div>
        </div>
        <CustomScrollRestoration />
        {/* Card Image Preview Popup */}
        {currentPreviewId && isPreviewVisible && (
          <div
            className="card-image-preview-popup" // CSS will handle mobile hiding
            style={{
              top: `${currentPreviewTop}px`,
              left: `${currentPreviewLeft}px`,
            }}
          >
            {isPreviewImageLoading && (
              <div className="d-flex justify-content-center align-items-center card-image-preview-spinner-container">
                <Spinner animation="border" variant="primary" role="status" size="sm">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            )}
            <img
              src={`/cards/${currentPreviewCardId}.webp`}
              alt={`${currentPreviewCardName || 'Card'} preview`}
              style={{ display: isPreviewImageLoading ? 'none' : 'block' }}
              onLoad={() => {
                // Only update if this image load corresponds to the currently active preview
                setHoveredCardPreview(prev =>
                  prev.id === currentPreviewId ? { ...prev, loadingImage: false } : prev
                );
              }}
              onError={() => {
                // If image fails, hide this specific preview attempt
                setHoveredCardPreview(prev =>
                  prev.id === currentPreviewId ? { ...prev, id: null, visible: false, loadingImage: false } : prev
                );
              }}
            />
          </div>
        )}
      </ModeratorActionProvider>
    </>
  );
}


export default App;
